import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";

import useFormOptionsApi from "./useFormOptionApi";
import prJson from "components/jsonData/purchase.json";
import { fetchAsyncGetSubCategory } from "redux/formOptions";
import useMinorOptions from "./useMinorOptions";

const useMinorSubOptions = (expenseType) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [minorSubCategoryOption, setMinorSubCategoryOption] = useState([]);
  const [minorSubCategoryValue, setMinorSubCategoryValue] = useState("");

  const {
    createMinorSubCategoryApi,
    deleteMinorSubCategoryApi,
    editMinorSubCategoryApi,
    getMinorSubCategoryApi
  } = useFormOptionsApi();

  const {subCategoryList} = useMinorOptions(expenseType);

  useEffect(() => {
    const fetchSubCategory = async () => {
      await dispatch(fetchAsyncGetSubCategory());
    };
    fetchSubCategory();
  }, [dispatch]);

 

  const getMinorSubOptions = (expenseId,subId)=>{
    getMinorSubCategoryApi(expenseId).then((subCatResult) => {
        if (subCatResult.success) {
          const minorSubOpt = subCatResult.data.map((item) => ({
            ...item,
            label: item?.lab,
            value: item?.val,
            id: item?._id,
          }));
          setMinorSubCategoryOption(minorSubOpt);

          if (subId) {
            const subCat = minorSubOpt.find((opt) => opt.id === subId);
            if (subCat) {
              setMinorSubCategoryValue({
                label: subCat?.label,
                value: subCat?.value,
                id: subCat?._id,
              });
            }
          }
          else{
            setMinorSubCategoryValue("")
          }
        }
      });
  }
  const createMinorSubCategory = (category, minorData) => {
    const option = subCategoryList.find((data) => data._id === minorData?.id);
    if (option){
      createMinorSubCategoryApi(option._id, category,expenseType).then((result) => {
          if (result.success) {    
            getMinorSubOptions(minorData?.id,result.data.id)
            addToast(prJson.success.createdMinorSub, { appearance: 'success' });
          } else {
            addToast(result.message, { appearance: 'error' });
          }
        });
    }
  };

  const deleteMinorSubCategory = (minorId,option) => {
    const id = option?._id;
    if (id) {
      deleteMinorSubCategoryApi(id).then((result) => {
          if (result.success) {
            getMinorSubOptions(minorId,id)

            addToast(prJson.success.deletedMinorSub, { appearance: 'success' });
          } else {
            addToast(result.message, { appearance: 'error' });
          }
        });
    }
  };
 
  const editMinorSubCategory = (minorId,option,newValue) => {
    editMinorSubCategoryApi(option?._id, newValue,expenseType).then((result) => {
      if (result.success) {
        getMinorSubOptions(minorId,option?._id)
        addToast(prJson.success.updatedMinorSub, { appearance: 'success' });
      } else {
        addToast(result.message, { appearance: 'error' });
      }
    });
  };
  return {
    minorSubCategoryOption,
    createMinorSubCategory,
    deleteMinorSubCategory,
    editMinorSubCategory,
    getMinorSubOptions,
    minorSubCategoryValue,
    setMinorSubCategoryValue
  };
};

export default useMinorSubOptions;
